<template>
    <el-drawer
        :title="id ? '编辑投票' : '创建投票'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        append-to-body
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                :model="formData"
                ref="formData"
                label-position="top"
            >
                <el-form-item prop="activityName" label="关联演出:" :rules="[{required: true, message: '请关联正确的演出'}]">
                    <el-input v-if="!id" placeholder="请输入演出ID" v-model="formData.activityId" size="medium" maxlength="7">
                        <el-button slot="append" icon="el-icon-s-opportunity" @click="searchEvent">检索</el-button>     
                    </el-input>
                    {{formData.activityName}}
                </el-form-item>
                <!-- <el-form-item prop="activityName" :rules="[{required: true, message: '请关联正确的演出'}]">
                    {{formData.activityName}}
                </el-form-item> -->
                <el-form-item prop="datetimerange" label="投票时间段:" :rules="[{type:'array', required: true, message: '请输入投票时间段', trigger:'change'}]">
                    <el-date-picker
                        v-model="formData.datetimerange"
                        type="datetimerange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        class="fl"
                        size="small"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['00:00:00', '23:59:59']"
                        unlink-panels
                        align="right"
                        >
                    </el-date-picker>
                </el-form-item>
                <el-form-item prop="specialAccounts">
                    <span slot="label">特殊账号: <el-button type="text" icon="el-icon-circle-plus" size="mini" @click="addAccount">添加账号</el-button></span>
                    <el-table
                        :data="formData.specialAccounts"
                        border
                        style="width: 100%"
                        size="small"
                        stripe
                    >
                        <el-table-column label="手机号">
                            <template slot-scope="scope">
                                <el-input placeholder="请输入特殊账号手机号" v-model="scope.row.tel" size="medium"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="拥有票数">
                            <template slot-scope="scope">
                                <el-input-number style="width:100%" v-model="scope.row.ticketNum" :precision="0" controls-position="right" :min="0" :max="99999999" size="medium" placeholder="请填写拥有票数"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="60">
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="delAccount(scope.$index)"
                                    >删除</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>

            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="onSubmit()" :loading="btnLoading">确 定</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    activityId: '',
    activityName: '',
    id: '',
    specialAccounts: [{
        id: '',
        tel: '',
        ticketNum: ''
    }],
    voteStartTime: '',
    voteEndTime: '',
    datetimerange:[]
}
export default {
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData: {
                ...defaultFormData
            },
            id:''
        }
    },
    methods:{
        close() {
            this.formData = {...defaultFormData};
            this.$refs['formData'].clearValidate();
            this.$refs['formData'].resetFields();
            this.drawerShow = false;
        },
        show(id){
            this.id = id || '';
            if( this.id ){
                this.getDataDetail();
            }
            this.drawerShow = true;
        },
        getDataDetail(){
            this.dataLoading = true;
            this.$request({
                url: "/vote/indieStar/info",
                params: { id: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.formData = {
                            ...defaultFormData,
                            ...result,
                            datetimerange: [result.voteStartTime || '' , result.voteEndTime || '']
                        }
                    } else {
                        this.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        addAccount(){
            this.formData.specialAccounts.push({
                tel:'',
                ticketNum:''
            })
        },
        delAccount(index){
            this.formData.specialAccounts = this.formData.specialAccounts.filter((v,i) => i !== index);
        },
        //搜索演出事件
        searchEvent() {
            if (this.formData.activityId !== "") {
                this.$request({
                    url: "/shop_good/activity",
                    params: {activityId:this.formData.activityId,type:1},
                    method: "post",
                })
                    .then((res) => {
                        const { state, result, msg } = res.data;
                        if (state == 1 && result && result.length > 0) {
                            this.formData.activityId = result[0].id;
                            this.formData.activityName = result[0].name;
                        }else{
                            this.$message.error(msg || '没有找到相关演出');
                        }
                    }).catch(() => {
                        this.$message.error('系统错误');
                    }).finally(() => {
                    });
            }
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/vote/indieStar/update',
                        method: "POST",
                        data: {
                            ...this.formData,
                            voteStartTime: this.formData.datetimerange[0],
                            voteEndTime: this.formData.datetimerange[1]
                        },
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
    }
}
</script>